import {
    getPrimaryQuerySyntaxIssue,
    validateLuceneQuerySyntax,
} from '@/views/storyboard/utils/validateLuceneQuerySyntax';

const serialize = (obj: Record<string, any>, prefix?: string): string => {
    const str: string[] = [];

    Object.entries(obj).forEach(([key, value]) => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const k = prefix ? `${prefix}[${key}]` : key;

            let v = value;

            if (key === 'additionalFilters' || key === 'all_fields') {
                // If value is already a string (pre-stringified), use as-is, otherwise stringify
                v = typeof value === 'string' ? value : JSON.stringify(value);
            } else if (key === 'aggs_item_list' && Array.isArray(value)) {
                // Handle aggs_item_list as array of JSON-stringified objects with [] notation
                value.forEach((item) => {
                    str.push(`${encodeURIComponent(k)}[]=${encodeURIComponent(JSON.stringify(item))}`);
                });
                return;
            } else if (key === 'filtering_lists' && Array.isArray(value)) {
                // Handle filtering_lists (lexicons) as array of JSON-stringified objects with [] notation
                value.forEach((item) => {
                    str.push(`${encodeURIComponent(k)}[]=${encodeURIComponent(JSON.stringify(item))}`);
                });
                return;
            } else if (typeof v === 'boolean') {
                v = +v;
            }

            // Skip null and undefined values to avoid sending them as "null" strings
            if (v !== null && v !== undefined) {
                str.push((typeof v === 'object')
                    ? serialize(v, k)
                    : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
            }
        }
    });

    return str.join('&');
};

const deserialize = (urlSearchParams: URLSearchParams): Record<string, any> => {
    const result: Record<string, any> = {};

    urlSearchParams.forEach((value, key) => {
        if (!Number.isNaN(Number.parseInt(value, 10))) {
            if (value.includes('.')) {
                result[key] = parseFloat(value);
            } else {
                result[key] = parseInt(value, 10);
            }
        } else {
            result[key] = value;
        }
    });

    return result;
};

const formatSearchKeyString = (value: string): string => {
    let str = '';

    str = value.split('_').join(' ');

    return str;
};

interface QueryStringErrors {
    query_string?: string;
}

const validateQueryString = (value: string): QueryStringErrors => {
    const primaryIssue = getPrimaryQuerySyntaxIssue(validateLuceneQuerySyntax(value));

    if (primaryIssue) {
        return {query_string: primaryIssue.message};
    }

    return {};
};

export {
    formatSearchKeyString,
    serialize,
    deserialize,
    validateQueryString,
};
